var KFooterElementPosition;
(function (KFooterElementPosition) {
    KFooterElementPosition["LEFT"] = "LEFT";
    KFooterElementPosition["CENTER"] = "CENTER";
    KFooterElementPosition["RIGHT"] = "RIGHT";
})(KFooterElementPosition || (KFooterElementPosition = {}));
var KFooterElementDirection;
(function (KFooterElementDirection) {
    KFooterElementDirection["HORIZONTAL"] = "HORIZONTAL";
    KFooterElementDirection["VERTICAL"] = "VERTICAL";
})(KFooterElementDirection || (KFooterElementDirection = {}));
var KFooterLinkType;
(function (KFooterLinkType) {
    KFooterLinkType["URL"] = "URL";
    KFooterLinkType["DIDOMI"] = "DIDOMI";
})(KFooterLinkType || (KFooterLinkType = {}));

export { KFooterElementDirection, KFooterElementPosition, KFooterLinkType };
//# sourceMappingURL=types.js.map
